module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('h3', [_vm._v("Atendimento")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('AgendadosNoDia')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('AtendimentosNoMomento')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('MediaAtendimento')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Estoque")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('EstoqueNoMomento')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('EstoqueUltimasBaixas')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bd821e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 289
// module chunks = 1